import axios from "axios"
import url from "../utils/url";

export const obtenerAseguradoras = async () => {
    return await axios.get(`${url}/api/aseguradoras`);
}

